module.exports = __webpack_public_path__ + "static/img/hos-hk-india-img-hong-kong-ctb01-02@t.e213ddd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hos-hk/hos-hk-india-img-hong-kong-ctb01-02@t.png
// module id = vLg/
// module chunks = 0